<template>
    <div class="xcb-subject-details">
        <div class="xcb-detail-top">
            <img v-if="isMirror10||isMirror5||isMirror7" src="@/assets/images/xcb-subject-banner10.jpg" alt />
            <img v-else src="@/assets/images/xcb-subject-banner.jpg" alt />
            <img src="@/assets/images/xcb-subject-mirror10-logo.png" alt="" v-if="isMirror10" class="logoMirror10">
            <img src="@/assets/images/xcb-subject-mirror5-logo.png" alt="" v-if="isMirror5" class="logoMirror5">
            <img src="@/assets/images/xcb-subject-mirror7-logo.png" alt="" v-if="isMirror7" class="logoMirror7">
            <a class="s-activity-apply-button xcb-button" href="javascript:;" @click="e=>this.changeTestLink('z')" v-if="!isMirror11"></a>
            <a href="javascript:;" class="apply-btn" @click="applyBtn" v-if="isMirror11"></a>
            <a href="javascript:;" @click="(e) => this.$router.push('/credit')" class="go-back xcb-activity-back"></a>
        </div>
        <div>
            <template v-if="isMirror10||isMirror5||isMirror7">
                <div class="xcb-detail-bottom">
                    <!-- <div
                        :class="{xcb_subject_wrapper_top10_bg:isMirror10,xcb_subject_wrapper_top7_bg:isMirror7}">
                    </div> -->
                    <div class="xcb-subject-wrapper" v-bind:class="{activeMirror10:isMirror10||isMirror5||isMirror7}">
                        <div class="xcb-subject-list">
                            <div class="subject-activity-item">
                                <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'jy',
                                            path: '/subject/xcb/activity/jy85',
                                        })
                                ">
                                    <img src="@/assets/images/xcb-subject-item-10-1@2x.png" alt />
                                </a>
                            </div>

                            <!-- <div class="subject-activity-item">
                                <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'th',
                                            path: '/subject/xcb/activity/thyc',
                                        })
                                ">
                                    <img src="@/assets/images/xcb-subject-item-10-3@2x.png" alt />
                                </a>
                            </div> -->
                            <!-- <div class="subject-activity-item">
                                <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'hf',
                                                link:'https://ccmall.srcb.com/impFront/campaignDetail/828?view=reward'
                                            }
                                        )
                                    ">
                                    <img src="@/assets/images/xcb-subject-item-10-4@2x.png" alt />
                                </a>
                            </div> -->
                            <div class="subject-activity-item">
                                <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'cx',
                                            path: '/subject/xcb/activity/cxfq',
                                        })
                                ">
                                    <img src="@/assets/images/xcb-subject-item-10-5@2x.png" alt />
                                </a>
                            </div>
                            <div class="subject-activity-item">
                                <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'tcly',
                                                link:'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=5&backallrights=true'
                                            }
                                        )
                                    ">
                                    <img src="@/assets/images/xcb-subject-item-10-6@2x.png" alt />
                                </a>
                            </div>
                            <div class="subject-activity-item">
                                <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'gbqy',
                                                link:'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=135&backallrights=true'
                                            }
                                        )
                                    ">
                                    <img src="@/assets/images/xcb-subject-item-10-7@2x.png" alt />
                                </a>
                            </div>
                            <!-- <div class="subject-activity-item">
                                <a href="javascript:;" @click="goBtn()">
                                    <img src="@/assets/images/hot-activity-lately-banner.png" alt />
                                </a>
                            </div> -->
                            <div class="subject-activity-item">
                                <div class="subject-activity-texts">
                                    <h3>年费标准</h3>
                                    <div class="text-content">
                                        <p>鑫驰白金卡</p>
                                        <p>年费标准：人民币480元/卡/年</p>
                                        <p>
                                            年费优惠政策：首年年费不减免，当年消费笔数满10笔且累计金额满5000元，或消费笔数满36笔不限金额可减免次年年费。
                                        </p>
                                        <!-- <p>活动时间：即日起至2021年9月30日</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="xcb-subject-wrapper-bottom" @click="testing()">
                    </div>
                </div>
            </template>
            <div v-else-if="isMirror11" class="xcb-subject-wrapper" v-bind:class="{activeMirror11:isMirror11}">
                <div class="xcb-subject-list">
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'jy',
                                            path: '/subject/xcb/activity/jy85?type=mirror11',
                                        })
                                ">
                            <img src="@/assets/images/xcb-subject-item-1@2x.png" alt />
                        </a>
                    </div>
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'syd',
                                            path: '/subject/activity/xcb/syd',
                                            
                                        })
                                ">
                            <img src="@/assets/images/xcb-subject-item-11-2@2x.png" alt />
                        </a>
                    </div>
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'xzj',
                                            path: '/subject/activity/xcb/xzj',
                                        })
                                ">
                            <img src="@/assets/images/xcb-subject-item-11-3@2x.png" alt />
                        </a>
                    </div>
                    <!-- <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'hf',
                                                link:'https://ccmall.srcb.com/impFront/campaignDetail/828?view=reward'
                                            }
                                        )
                                    ">
                            <img src="@/assets/images/xcb-subject-item-4@2x.png" alt />
                        </a>
                    </div> -->
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                            test:'cx',
                                            path: '/subject/xcb/activity/cxfq?type=mirror11',
                                        })
                                ">
                            <img src="@/assets/images/xcb-subject-item-5@2x.png" alt />
                        </a>
                    </div>
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'tcly',
                                                link:'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=5&backallrights=true'
                                            }
                                        )
                                    ">
                            <img src="@/assets/images/xcb-subject-item-6@2x.png" alt />
                        </a>
                    </div>
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'gbqy',
                                                link:'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=135&backallrights=true'
                                            }
                                        )
                                    ">
                            <img src="@/assets/images/xcb-subject-item-7@2x.png" alt />
                        </a>
                    </div>
                    <!-- <div class="subject-activity-item">
                        <a href="javascript:;" @click="goBtn()">
                            <img src="@/assets/images/hot-activity-lately-banner.png" alt />
                        </a>
                    </div> -->


                    <div class="subject-activity-item">
                        <div class="subject-activity-texts">
                            <h3>年费标准</h3>
                            <div class="text-content">
                                <p>鑫驰白金卡</p>
                                <p>年费标准：人民币480元/卡/年</p>
                                <p>
                                    年费优惠政策：首年年费不减免，当年消费笔数满10笔且累计金额满5000元，或消费笔数满36笔不限金额可减免次年年费。
                                </p>
                                <!-- <p>活动时间：即日起至2021年9月30日</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="xcb-subject-wrapper" v-bind:class="{activeMirror:!isMirror10&&!isMirror5&&!isMirror7&&!isMirror11}">
                <div class="xcb-subject-list">
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'tcly',
                                                link:'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=5&backallrights=true'
                                            }
                                        )
                                    ">
                            <img src="@/assets/images/xcb-subject-item-6@2x.png" alt />
                        </a>
                    </div>
                    <div class="subject-activity-item">
                        <a href="javascript:;" @click="
                                    (e) =>
                                        goToPath({
                                                test:'gbqy',
                                                link:'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=135&backallrights=true'
                                            }
                                        )
                                    ">
                            <img src="@/assets/images/xcb-subject-item-7@2x.png" alt />
                        </a>
                    </div>
                    <!-- <div class="subject-activity-item">
                        <a href="javascript:;" @click="goBtn()">
                            <img src="@/assets/images/hot-activity-lately-banner.png" alt />
                        </a>
                    </div> -->


                </div>
            </div>

        </div>
        <div class="layer-box" v-if="isShowMask">
            <div class="layer-mask"></div>
            <div class="img-box">
                <img src="@/assets/images/xcb/mirror11/layer_apply.png" alt="">
                <a href="javascript:;" class="closeBtn" @click="closeBtn"></a>
            </div>            
        </div>

    </div>
</template>

<script>
    import {
        setUpdateShare
    } from '@/lib/wechart';
    import shareUrl from '@/assets/images/share.jpg';
    import {
        mapState
    } from "vuex";
    import CommonBottomBanner from '@/components/commonBottomBanner'
    export default {
        components: {
            CommonBottomBanner
        },
        data() {
            return {
                isMirror10: false,
                isMirror5: false,
                isMirror7: false,
                isMirror11:false,
                isShowMask:false,
            };
        },
        mounted() {
            this.init();
        },
        computed: {
            ...mapState(["mirrorStatus", "mirror"]),
        },
        methods: {
            applyBtn(){                
                this.isShowMask = true;
                this.$test('z11 a-register-2');
            },
            closeBtn(){
                this.isShowMask = false;
            },
            init() {
                let type = this.$route.query.type;
                console.log(type)
                if (type) {
                    switch (type) {
                        case "mirror":
                            this.$store.commit("changeMirror", 0);
                            break;

                        default:
                            let index = type.match(/\d+?$/)[0];

                            if (index) {
                                this.$store.commit("changeMirror", index - 1);
                            }
                    }
                } else {
                    if (this.mirrorStatus) {
                        this.$store.commit("changeMirror", this.mirrorStatus);
                    }
                }
                if (this.mirrorStatus == 10) {
                    this.isMirror11 = true;
                    
                    setUpdateShare({
                        title: "加油8.5折，全年最高返利3600元！",
                        desc: "更有各类优惠活动！",
                        url: window.location.href,
                        image: shareUrl
                    })
                }
                if (this.mirrorStatus == 9) {
                    this.isMirror10 = true;
                    setUpdateShare({
                        title: "加油8.5折，全年最高返利3600元！",
                        desc: "更有各类优惠活动！",
                        url: window.location.href,
                        image: shareUrl
                    })
                }
                if (this.mirrorStatus == 4) {
                    this.isMirror5 = true;
                    setUpdateShare({
                        title: "加油8.5折，全年最高返利3600元！",
                        desc: "更有各类优惠活动！",
                        url: window.location.href,
                        image: shareUrl
                    })
                }
                if (this.mirrorStatus == 6) {
                    this.isMirror7 = true;
                    setUpdateShare({
                        title: "加油8.5折，全年最高返利3600元！",
                        desc: "更有各类优惠活动！",
                        url: window.location.href,
                        image: shareUrl
                    })
                }
            },
            goToPath(route) {
                console.log(route)
                this.$test(
                    `${route.test}${this.mirrorStatus ? this.mirrorStatus + 1 : ""}-banner`
                );
                if (route.link) {
                    window.location.href = route.link;
                } else {
                    this.$router.push(route.path);
                }
            },
            changeTestLink(type) {
                console.log(this.mirror.current_link)
                // return;
                this.$test(
                    `${type}${this.mirrorStatus ? this.mirrorStatus + 1 : ""} a-register-2`
                );
                this.$router_push(this.mirror.current_link);
            },
            goBack() {
                this.$router.back();
            },
            testing() {
                if (this.isMirror5) {
                    this.$test('hd5-banner');
                }
                if (this.isMirror7) {
                    this.$test('hd7-banner');
                }
                if (this.isMirror10) {
                    this.$test('hd10-banner');
                }
                window.location.href = "http://www.diyelf.com/srcb_hct/";
            },
            // goBtn() {
            //     this.$test('hot-activity')
            //     window.location.href = 'http://www.diyelf.com/srcb_hct/'
            // }
        },
    };
</script>

<style lang="scss" scoped>
</style>